module.exports = __webpack_public_path__ + "static/media/tortlelookingfromtop.82b5fd15.png";